import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SMSAuth } from './components/SMSAuth';
import { Dashboard } from './ui/Dashboard';
import Terms from './Terms';
import Privacy from './Privacy';

interface User {
  phone: string;
  token: string;
}

function App() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing session
    const savedToken = localStorage.getItem('sms_auth_token');
    const savedPhone = localStorage.getItem('sms_auth_phone');
    
    if (savedToken && savedPhone) {
      setUser({ token: savedToken, phone: savedPhone });
    }
    setLoading(false);
  }, []);

  const handleAuthenticated = (token: string, phone: string) => {
    localStorage.setItem('sms_auth_token', token);
    localStorage.setItem('sms_auth_phone', phone);
    setUser({ token, phone });
  };

  const handleLogout = () => {
    localStorage.removeItem('sms_auth_token');
    localStorage.removeItem('sms_auth_phone');
    setUser(null);
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/" element={
          !user ? (
            <SMSAuth onAuthenticated={handleAuthenticated} />
          ) : (
            <Dashboard user={user} onLogout={handleLogout} />
          )
        } />
      </Routes>
    </Router>
  );
}

export default App;
